import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

interface RecordJson {
  token: string;
}

export const uploadConvertData = (json: RecordJson): any =>
  http.httpPost({
    url: httpApi.sw.uploadConvertData,
    json,
  });

// 百度联调
interface UploadConvertDatabdVidJson {
  logidUrl: string;
}

export const uploadConvertDatabdVid = (json: UploadConvertDatabdVidJson): any =>
  http.httpPost({
    url: httpApi.sw.uploadConvertDatabdVid,
    json,
  });
